import { Button, DottedBox, FoodsIcon, Typography } from "@foodpilot/foods";
import { useTheme } from "@mui/material";
import type { ReactNode } from "react";

export type AddItemFieldProps = {
    actionLabel: string;
    description?: ReactNode;
    onAction: () => void;
};

/** Shared empty/add-another field for repeatable entity form rows. */
export const AddItemField = ({ actionLabel, description, onAction }: AddItemFieldProps) => {
    const theme = useTheme();

    return (
        <DottedBox
            variant="themed"
            BoxPropsSxOverride={{
                alignItems: "center",
                backgroundColor: theme.palette.primary[50],
                border: "none",
                borderRadius: theme.spacing(1),
                boxSizing: "border-box",
                gap: theme.spacing(1),
                padding: theme.spacing(2),
                position: "relative",
                textAlign: "center",
                width: "100%",
                "&::after": {
                    borderColor: theme.palette.primary[600],
                    borderRadius: "inherit",
                    borderStyle: "dashed",
                    borderWidth: theme.custom.strokes.containerDivider.width,
                    boxSizing: "border-box",
                    content: '""',
                    inset: 0,
                    pointerEvents: "none",
                    position: "absolute",
                },
            }}
        >
            <>
                {description !== undefined && (
                    <Typography variant="body-regular" sx={{ color: theme.custom.grey[2500] }}>
                        {description}
                    </Typography>
                )}
                <Button
                    type="button"
                    variant="text"
                    startIcon={<FoodsIcon icon="plus" size={2} />}
                    onClick={onAction}
                    sx={{
                        ...theme.typography.cta,
                        color: theme.palette.primary[700],
                        columnGap: theme.spacing(1),
                        height: "auto",
                        minWidth: "auto",
                        padding: 0,
                        textTransform: "none",
                        "& .MuiButton-startIcon": { margin: 0 },
                        "& .MuiSvgIcon-root": {
                            height: theme.spacing(2),
                            width: theme.spacing(2),
                        },
                    }}
                >
                    {actionLabel}
                </Button>
            </>
        </DottedBox>
    );
};
